import { render, staticRenderFns } from "./ModuleNotifications.vue?vue&type=template&id=5c311f50&scoped=true&"
import script from "./ModuleNotifications.vue?vue&type=script&lang=js&"
export * from "./ModuleNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNotifications.vue?vue&type=style&index=0&id=5c311f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c311f50",
  null
  
)

export default component.exports